import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import WorksRail from "@/pages/home/components/WorksRail";
import StarHighlights from "@/pages/home/components/StarHighlights";
import BrandIntro from "@/pages/home/components/BrandIntro";
import { useSEO } from "@/hooks/useSEO";

export default function Home() {
  useSEO({
    title: "朝桐光 - 官方影视资讯与作品展示",
    description:
      "朝桐光品牌影视类网站，提供最新影视作品介绍、明星动态及相关资讯，满足影迷对朝桐光相关内容的全面了解与探索。",
    keywords: "朝桐光,影视作品,明星资讯,影视动态,影视品牌",
  });

  return (
    <div className="flex flex-col">
      <HeroCarousel />
      <div className="relative z-20 -mt-10 md:-mt-12">
        <CategoryEntries />
      </div>

      <section className="mx-auto mt-16 w-full max-w-page px-4 md:mt-20 md:px-6">
        <WorksRail />
      </section>

      <section className="mx-auto mt-16 w-full max-w-page px-4 md:mt-20 md:px-6">
        <StarHighlights />
      </section>

      <div className="mt-16 md:mt-24">
        <BrandIntro />
      </div>
    </div>
  );
}